<div class="container-fluid row_banner ">
  <app-header></app-header>
  <div class="container">
    <h1 class="abbout-title justify-content-center mt-4">Contact Us</h1>
    <div class="container my-5">
      <div class="row mission-section">
        <p class="abbout-title-phone justify-content-center mt-4">Contact Us</p>
        <div class="col-md-6 left-section ">
          <div class="info-section  mb-2">
            <div class="contactTabsA">
              <div class="mIMG">
                <app-icons-free-tools name="chatMessageIcon" />
                 </div>
              <p class="mb-0 mt-1 mbl-screen contactF">For any
                questions, comments, complaints or suggestions, feel free to contact us on the details provided below.
              </p>
            </div>
          </div>
          <div class="info-section  mb-2">
            <div class="contactTabsA">
              <div class="mIMG">

                  <app-icons-free-tools name="supportClockIcon" />
                </div>
              <p class="mb-0 mt-1 mbl-screen contactF">
                Our support team is available 24/7 to assist you,and it is our pleasure to help wherever we can.
              </p>
            </div>
          </div>
          <div class="info-section-c  mb-4              ">
            <div class="align-items-start info-section-cd">
              <h2 class="mbl-contact cont-fnt"> Contact Information</h2>
              <p class="mbl-screen contDetail">
                Fill up the form and our Team will get <br class="d-md-block d-none"> back to you within 24 hours.</p>
              <div class="cont-sup">
                <div>         <app-icons-free-tools name="emailContactIcon" /> </div>
                <p class="cont-info-t contDetail">
                  <a href="mailto:support@grammarin.com" style="text-decoration: none;color: black;">support&#64;grammarin.com</a></p>
              </div>
              <div class="cont-sup mrg10">
                <div>  <app-icons-free-tools name="locationGlobalIcon" />
                </div>
                <p class="cont-info-t contDetail"><a [routerLink]="['/']" style="text-decoration: none;color: black">https://grammarin.com</a> </p>
              </div>
            </div>
            <div class="cont-sup"> <img src="../../assets/images/contact-us/bg.svg" alt="support image" height="156px"
                width="450px" class="cont-sup-img"> </div>
          </div>
        </div>
        <div class="col-md-6 ">
          <div class="contact-form pform">
            <h2 class="contact-form-h5">Get in
              touch with our team</h2>
            <p class="mt-2 contact-form-pa">We're here to help! Whether you have a question, feedback, or just want to
              say hello, feel
              free to reach out to us through any of the channels below. Our team is eager to assist you.</p>

              <p
              class="text-left success-msg"
              *ngIf="got_recpatcha"
              [ngStyle]="{
                color: color,
                'background-color': '#f8d7da',
                padding: '2px'
              }"
            >
              <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
              {{ recaptcha_message }}
            </p>

            <form style="margin-top: 30px;">


              <p class="text-left success-msg  success-alter" id="eFsubText" [ngStyle]="{ color: color }" *ngIf="eFsub"
                style="margin-bottom: 5px; margin-top: -5px"> <i class="fas fa-check-circle" aria-hidden="true"
                  style="margin-right: 3px"></i> {{ eFsubText }} </p>
              <p class="text-left success-msg alert-danger" id="eFsubText" [ngStyle]="{ color: color }" *ngIf="eFsuberror"
                style="margin-bottom: 5px; margin-top: -5px"> <i class="fa fa-times-circle" aria-hidden="true"
                  style="margin-right: 3px"></i> {{ eFsubText }} </p>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="firstName" class="form-label">First Name*</label>
                  <input id="form_name" type="text" name="form_name" class="form-control bd-light" value="" />
                </div>
                <div class="col-md-6">
                  <label for="lastName" class="form-label">Last Name*</label>
                  <input id="form_lastname" type="text" name="form_lastname" class="form-control bd-light" value="" />
                </div>
              </div>
              <div class="mb-3">
                <label for="email" class="form-label">Email*</label>
                <input id="form_email" type="email" name="form_email" class="form-control bd-light" value="" />
              </div>
              <div class="mb-3">
                <label for="subject" class="form-label">Subject*</label>
                <input id="form_subject" type="text" name="form_subject" class="form-control bd-light" value="" />
              </div>
              <div class="mb-4">
                <label for="message" class="form-label">Message*</label>
                <textarea id="form_message" name="form_message" class="form-control bd-light" rows="7"></textarea>
              </div>

              <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                <div class="captcha-modal">
                  <div id="recaptcha-container" class="recaptcha-container" data-size="compact" data-theme="light"></div>
                </div>
              </div>


              <button type="submit" class="btn btn-dark w-100 submitBtn"
                (click)="handleButtonClickGetTouch()">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<a (click)="scrollToTop()" *ngIf="shouldShowButton" id="scroll-to-top" data-tooltip="Go to top">

  <app-icons-free-tools name="goToTopIcon" />
</a>
<app-footer></app-footer>
